module.exports = __webpack_public_path__ + "static/user-story-curated-storefront-v2-OberionIO.min-ba61f39f14df9699941a999a8b79d9b0.svg";